<template>
    <div>
        <ul class="nav nav-pills" role="tablist">
            <li class="nav-item" @click="changeBoard(1)">
                <router-link :class="['nav-link', tab == 'transactions-list' ? 'active' : '']"
                    to="/transactions/starshop/transactions-list" data-toggle="tab" role="tab" aria-selected="false"
                    style="cursor:pointer;">
                    {{ $t('dashboard.label.transaction_list') }}
                </router-link>
            </li>
            <li class="nav-item" @click="changeBoard(0)">
                <router-link :class="['nav-link', tab == 'excels-list' ? 'active' : '']"
                    to="/transactions/starshop/excels-list" data-toggle="tab" role="tab" aria-selected="false"
                    style="cursor:pointer;"
                    v-if="$can('export-excel','transaction')">
                <!-- > check later -->

                    {{ $t('dashboard.label.excel_exports_list') }}
                </router-link>
            </li>
        </ul>

        <div class="tab-content">
            <div v-if="current_user.permissions.length > 0" id="transactions-list" :class="['tab-pane', tab == 'transactions-list' ? 'active' : '']">
                <admin-transaction-filter v-if="$can('read','transaction')" :action="filterAction"
                    :query="query_filter" form_id=""></admin-transaction-filter>
                <transaction-filter v-else :action="filterAction" :query="query_filter" form_id=""></transaction-filter>
                <div>
                    <kt-row v-if="$can('read', 'transaction')">
                        <div class="col-lg-3 col-md-3 col-sm-6" v-if="hasWageTransactionAccess">
                            <transactionStat :transactionStatistics="showDefaultIfNotLoaded(statistics.total_profit)"
                                :title="$t('label.total_benefit')" :needCurrency="true" />
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6">
                            <transactionStat
                                :transactionStatistics="showDefaultIfNotLoaded(statistics.transactions_sum)"
                                :title="$t('label.total_transactions')" :needCurrency="true" />
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6">
                            <transactionStat
                                :transactionStatistics="showDefaultIfNotLoaded(statistics.succeeded_trans_count)"
                                :title="$t('label.succeeded_transactions_number')" :needCurrency="false" />
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6 ">
                            <div class="kt-portlet">
                                <div class="kt-portlet__body" style="color: black; background-color: #fff">
                                    <h6> {{ $t('label.calculate_statistics') }}</h6>
                                    <div class="text-center">
                                        <h5 class="fix-margin">
                                            {{ statistics.last_updated }}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="position-absolute" style="left:20px;top:5px;cursor: pointer;">
                                <button class="no-border" @click="updateReport()">
                                    <i class="fa flaticon-refresh"
                                        :class="[isStatisticLoading(status) ? 'fa-spin' : '']" aria-hidden="true"
                                        style="font-size: 1.6em; color: #0f9af0" :title="$t('label.reportUpdate')">
                                    </i>
                                </button>
                            </div>
                        </div>
                    </kt-row>
                    <kt-row v-else>
                        <div class="col-lg-4 col-md-4 col-sm-6">
                            <transactionStat
                                :transactionStatistics="showDefaultIfNotLoaded(statistics.transactions_sum)"
                                :title="$t('label.total_transactions')" :needCurrency="true" />
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6">
                            <transactionStat
                                :transactionStatistics="showDefaultIfNotLoaded(statistics.succeeded_trans_count)"
                                :title="$t('label.succeeded_transactions_number')" :needCurrency="false" />
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6">
                            <transactionStat
                                :transactionStatistics="showDefaultIfNotLoaded(statistics.failed_trans_count)"
                                :needCurrency="false" :title="$t('label.failed_transactions_number')" />
                        </div>
                    </kt-row>
                    <kt-datatable v-if="$can('read','transaction')" v-bind="datatableProps" ref="datatable">
                    </kt-datatable>

                    <kt-datatable v-else v-bind="datatablePropsUser" ref="datatable">
                    </kt-datatable>
                </div>
            </div>

            <div id="excels-list" :class="['tab-pane', tab == 'excels-list' ? 'active' : '']">
                <admin-transaction-filter v-if="$can('export-excel', 'transaction')" :action="exportToExcel"
                    :query="query_filter_excel" :form_id="excel_filter_form_id" />
                <transaction-filter v-else :action="exportToExcel" :query="query_filter_excel"
                    :form_id="excel_filter_form_id" />
                <div class="fh-datatable bg-white">
                    <table v-if="excelRequests.data.length > 0" class="table table-light-bordered">
                        <thead>
                            <tr style="font-size: 0.89rem;">
                                <td style="text-align: center; width:70px">#</td>
                                <td style="text-align: center">{{ $t('label.from_date') }}</td>
                                <td style="text-align: center">{{ $t('label.to_date') }}</td>
                                <td>{{ $t('label.status') }}</td>
                                <td style="text-align: center">عملیات</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(req, index) in excelRequests.data">
                                <td style="text-align: center">{{ req.id }}</td>
                                <td style="text-align: center">{{ req.from_date }}</td>
                                <td style="text-align: center">{{ req.to_date }}</td>
                                <td style="text-align: center" class="text-center">
                                    <div class="text-white" :class="excelStatusVariant(req.status)">
                                        {{ excelStatusStr(req.status) }}
                                    </div>
                                </td>
                                <td class="text-center d-flex justify-content-center align-items-center">
                                    <a v-show="req.url" :href="req.url" type="button"
                                        style="background: none; border: none; color: #7878e4">
                                        <i class="fa fa-download"></i>
                                    </a>
                                    <button @click="handleReqDelete(req.id)"
                                        style="background: none; border: none; color: #c90000">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="excelRequests.data.length > 0" class="pager kt-datatable--paging-loaded">
                        <div class="paginationR">
                            <button class="btn-link" title="اولی" @click="changePage(1)">
                                &laquo;&laquo;
                            </button>
                            <button class="btn-link" title="قبلی" @click="changePage(excelRequests.current_page - 1)">
                                &laquo;
                            </button>
                            <span
                                v-for="(page, index) in ((excelRequests.current_page) - 2, excelRequests.current_page + 2)"
                                :key="index">
                                <button
                                    v-if="(page <= excelRequests.last_page) && page > excelRequests.current_page - 3"
                                    @click="changePage(page)" :id="'page_' + page"
                                    :class="{ 'active': (excelRequests.current_page == index + 1) }">
                                    {{ page }}
                                </button>
                            </span>
                            <button class="btn-link" title="بعدی" @click="changePage(excelRequests.current_page + 1)">
                                &raquo;
                            </button>
                            <button class="btn-link" title="آخری" @click="changePage(excelRequests.last_page)">
                                &raquo;&raquo;
                            </button>
                        </div>
                        <div class="pager-info">
                            <select class="mr-3 ml-3 kt-datatable__pager-size" style="width: 60px;" title="اندازه صفحه"
                                @change="changePage(excelRequests.current_page)" id="perpage-value" v-model="per_page">
                                <option value="15">15</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                            </select>
                            <span class="kt-datatable__pager-detail">
                                {{ 'نمایش ' + excelRequests.from + ' - ' + excelRequests.to + ' از ' +
                                    excelRequests.total }}
                            </span>
                        </div>
                    </div>
                    <div v-else class="text-center p-5 my-3">
                        درخواست خروجی اکسل برای شما وجود ندارد!
                    </div>
                </div>
                <div class="loader" style="display:none"></div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { ApiUrl, transactionService } from '@/common/api.service'
import columns from './../datatable/columns'
import commonAccessColumns from '../datatable/starshopCommonAccessColumns'
import { AuthorizationHeader } from '@/common/jwt.service'
import transactionFilter from './transaction-filter'
import transactionStat from './transaction-statistic'
import { mapGetters } from "vuex";
import { KTApp } from "@/plugins/core/app";
import adminTransactionFilter from './admin-transaction-filter'
import { i18n } from "@/plugins/i18n";
import toastr from "toastr";
import actionsColumn from "../../transaction/components/starshop-action.vue"
export default {
    components: {
        transactionFilter,
        adminTransactionFilter,
        transactionStat,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            query_filter: {
                transaction_type: [],
            },
            query_filter_excel: {},
            per_page: 15,
            page: 1,
            isFirstTimeToLoadStatistics: true,
            excel_filter_form_id: 'excel',
        }
    },
    computed: {
        ...mapGetters('user', [
            'current_user'
        ]),
        tab() {
            if (this.$route.params.tab) {
                return this.$route.params.tab;
            }

            return 'transactions-list';
        },
        hasWageTransactionAccess() {
            let hasAccess = this.current_user.permissions.filter(rule => rule.subject === 'transaction')[0].actions.includes('read-wages')
            let hasAllAccess = this.current_user.permissions.filter(rule => rule.subject === 'all').length > 0

            return hasAccess || hasAllAccess
        },
        datatableProps() {
            return {
                id: "user_transaction_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.starshopPath('admin/transaction'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                // this.$refs.datatable.reload()

                                return res.data.data
                            },
                            params: {
                                query: this.query_filter
                            },
                        }
                    },
                    // saveState: {
                    //     // save datatable state(pagination, filtering, sorting, etc) in cookie or browser webstorage
                    //     cookie: true,
                    //     webstorage: false,
                    // },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },

                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
        datatablePropsUser() {
            return {
                id: "user_transaction_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.starshopPath('transaction'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                // this.$refs.datatable.reload()

                                return res.data.data
                            },
                            params: {
                                query: this.query_filter
                            },
                        }
                    },
                    // saveState: {
                    //     // save datatable state(pagination, filtering, sorting, etc) in cookie or browser webstorage
                    //     cookie: true,
                    //     webstorage: false,
                    // },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },

                pagination: false,
                sortable: true,
                columns: commonAccessColumns,
            }
        },
        ...mapGetters('transaction', [
            'statistics', 'status', 'excelRequests'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        }
    },
    methods: {
        handleReqDelete(hashid) {
            transactionService.deleteStarshopExcelRequest(hashid)
                .then(response => {
                    this.$store.dispatch('transaction/fetchStarshopExcelRequests', this.params).finally(() => {
                        localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
                    })
                    this.toastr.success(response.data.message);
                })
                .catch(({ response }) => {
                    this.toastr.error(response.data.message);
                })
        },
        fillParams() {
            this.params = {
                page: this.page,
                perpage: this.per_page,
            }
        },
        changePage(pagee) {
            this.page = pagee
            this.fillParams()
            this.$store.dispatch('transaction/fetchStarshopExcelRequests', this.params).finally(() => {
                localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
            })
        },
        excelStatusVariant(status) {
            if (status == "PROCESSING")
                return "badge badge-warning"

            if (status == "PROCESSED")
                return "badge badge-success"
        },
        excelStatusStr(status) {
            if (status == "PROCESSING")
                return i18n.t('transaction.excelStatus.processing')

            if (status == "PROCESSED")
                return i18n.t('transaction.excelStatus.processed')
        },
        updateReport() {
            this.isFirstTimeToLoadStatistics = false;
            if (this.$can('read', 'transaction')) {
                this.$store.dispatch('transaction/fetchAdminStarshopStatistics', this.query);
            } else {
                this.$store.dispatch('transaction/fetchStarshopStatistics', this.query);
            }
        },
        changeBoard(board) {
            this.board = board;
        },
        filterAction(e, query) {
            let form = $('#transaction-filter-form');

            form.validate({
                rules: {
                    transaction_type: {
                        required: () => {
                            if (query.phone) return true;
                        },
                    },
                },
            });

            if (!form.valid()) {
                return;
            }

            this.query = query
            if (this.query.sheba) {
                let sheba = this.query.sheba
                sheba = sheba.split('-').join('')
                sheba = sheba.split(' ').join('')
                sheba = sheba.split('_').join('')

                query.sheba = sheba
            }
            this.query_filter = query

            // if (this.$refs.datatable.KTDatatable) {
            //     this.$refs.datatable.reload()
            // }
            this.$refs.datatable.reload();
            // this.$store.dispatch('transaction/fetchStatistics', query)
        },
        exportToExcel(e, query) {
            let btn = $(e.target);
            let form = $('#transaction-filter-form' + this.excel_filter_form_id)

            form.validate({
                rules: {
                    from_date: {
                        required: true,
                    },
                    to_date: {
                        required: true,
                    },
                },
            });

            if (!form.valid()) {
                return;
            }

            KTApp.progress(btn)

            this.query_filter_excel = query

            if (this.query_filter_excel.sheba) {
                let sheba = this.query_filter_excel.sheba
                sheba = sheba.split('-').join('')
                sheba = sheba.split(' ').join('')
                sheba = sheba.split('_').join('')
                this.query_filter_excel.sheba = sheba
            }
            transactionService.createStarshopExcelRequest({
                query: this.query_filter_excel
            }).then(async (response) => {
                await this.$store.dispatch('transaction/fetchStarshopExcelRequests')
                this.toastr.success(response.data.message)
            }).catch(({ response }) => {
                form.validate().showErrors(response.data.data)
            }).finally(() => {
                KTApp.unprogress(btn)
            });
        },
        isStatisticLoading(status) {
            return (status === 'loading') && !this.isFirstTimeToLoadStatistics;
        },
        showDefaultIfNotLoaded(val) {
            return (val === 0) ? '-' : val
        }
    },
    async mounted() {
        await this.$store.dispatch('user/fetchCurrent')
        this.fillParams()
        this.$store.dispatch('transaction/fetchStarshopExcelRequests', this.params).finally(() => {
            localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
        })
        // this.$store.dispatch('transaction/fetchStatistics')
    },
}
</script>